import { IFramePlayerAbstractClass } from 'iframe/ts/player/abstract/IFramePlayerAbstractClass';
import { IFramePlayerPostMessageInHandler } from 'iframe/ts/player/controller/IFramePlayerPostMessageInHandler';
import { IFramePlayerEvent } from 'iframe/ts/player/events/IFramePlayerEvent';
export class IFramePlayerPostMessageHub extends IFramePlayerAbstractClass {
    #parentWindow;
    #postMessageInHandler;
    constructor(iframePlayer) {
        super(iframePlayer, 'IFramePlayerPostMessageHub');
        this.#postMessageInHandler = new IFramePlayerPostMessageInHandler(iframePlayer);
        this.#parentWindow = window?.parent;
        this.#startListeningToPostMessage().then((data) => {
            this.dispatchIFramePlayerEvent({
                type: IFramePlayerEvent.ON_POST_MESSAGE_HUB_READY,
                target: this,
                targetName: this.name
            });
        });
    }
    #startListeningToPostMessage = () => {
        return new Promise((resolve, reject) => {
            window.addEventListener('message', this.#postMessageInHandler.onPostMessage);
            resolve({ msg: 'Post message event listener added', success: true });
        });
    };
    #stopListeningToPostMessage = () => {
        return new Promise((resolve, reject) => {
            window.removeEventListener('message', this.#postMessageInHandler.onPostMessage);
            resolve({ msg: 'Post message event listener removed', success: true });
        });
    };
    postMessage = (message) => {
        const executePostMessage = () => {
            if (!this.utils.Type.isUndefined(this.#parentWindow)) {
                try {
                    this.#parentWindow.postMessage(this.utils.Object.cloneForPostMessage(message), '*');
                }
                catch (error) {
                    this?.logger?.warn('postMessage: ERROR:', error, 'message:', message);
                }
            }
        };
        this.utils.Delay.delay().then(() => executePostMessage());
    };
}
